import React from 'react';
import { Link } from 'react-router-dom';

// 直接在組件中嵌入SVG代碼
const BannerSVG = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 400" className="w-full h-auto rounded-lg shadow-xl">
        {/* 背景漸層 */}
        <defs>
            <linearGradient id="bgGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#2563eb" />
                <stop offset="100%" stopColor="#1e40af" />
            </linearGradient>
            <linearGradient id="textGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#ffffff" />
                <stop offset="100%" stopColor="#f3f4f6" />
            </linearGradient>
            <linearGradient id="highlightGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#22d3ee" />
                <stop offset="100%" stopColor="#0ea5e9" />
            </linearGradient>
            <filter id="dropShadow" x="-20%" y="-20%" width="140%" height="140%">
                <feGaussianBlur in="SourceAlpha" stdDeviation="3" />
                <feOffset dx="2" dy="2" />
                <feComponentTransfer>
                    <feFuncA type="linear" slope="0.3" />
                </feComponentTransfer>
                <feMerge>
                    <feMergeNode />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>
            <clipPath id="deviceShape">
                <rect x="780" y="100" width="280" height="200" rx="10" ry="10" />
            </clipPath>
        </defs>

        {/* 主背景 */}
        <rect width="1200" height="400" fill="url(#bgGradient)" />

        {/* 裝飾元素 - 圓形 */}
        <circle cx="150" cy="80" r="60" fill="#3b82f6" opacity="0.2" />
        <circle cx="1100" cy="320" r="80" fill="#3b82f6" opacity="0.2" />
        <circle cx="950" cy="50" r="40" fill="#3b82f6" opacity="0.2" />

        {/* 裝飾元素 - 波浪線 */}
        <path d="M0,280 Q300,220 600,280 T1200,240" fill="none" stroke="#3b82f6" strokeWidth="2" opacity="0.3" />
        <path d="M0,300 Q300,380 600,320 T1200,350" fill="none" stroke="#3b82f6" strokeWidth="2" opacity="0.3" />

        {/* 左側文字內容 */}
        <g filter="url(#dropShadow)">
            <text x="120" y="150" fontFamily="Arial, sans-serif" fontSize="40" fontWeight="bold" fill="url(#textGradient)">
                智能出勤與人事管理
            </text>
            <text x="120" y="200" fontFamily="Arial, sans-serif" fontSize="48" fontWeight="bold" fill="url(#highlightGradient)">
                提升管理效率
            </text>
            <text x="120" y="240" fontFamily="Arial, sans-serif" fontSize="24" fill="#ffffff" opacity="0.9">
                一體化解決方案 · SaaS服務模式 · 彈性訂閱
            </text>
        </g>

        {/* 功能圖標 */}
        <g transform="translate(120, 280)">
            {/* Clock icon */}
            <circle cx="30" cy="30" r="25" fill="#ffffff" opacity="0.9" />
            <path d="M30,15 L30,30 L40,38" stroke="#2563eb" strokeWidth="3" strokeLinecap="round" fill="none" />
            <circle cx="30" cy="30" r="28" stroke="#ffffff" strokeWidth="2" fill="none" opacity="0.8" />

            {/* Location icon */}
            <circle cx="110" cy="30" r="25" fill="#ffffff" opacity="0.9" />
            <path d="M110,20 C103,20 98,25 98,32 C98,38 110,48 110,48 C110,48 122,38 122,32 C122,25 117,20 110,20 Z" stroke="#2563eb" strokeWidth="1" fill="#2563eb" />
            <circle cx="110" cy="30" r="5" fill="#ffffff" />

            {/* Chart icon */}
            <circle cx="190" cy="30" r="25" fill="#ffffff" opacity="0.9" />
            <path d="M180,40 L180,30 L190,30 L190,20 L200,20 L200,40" stroke="#2563eb" strokeWidth="3" strokeLinecap="round" fill="none" />

            {/* User icon */}
            <circle cx="270" cy="30" r="25" fill="#ffffff" opacity="0.9" />
            <circle cx="270" cy="23" r="8" stroke="#2563eb" strokeWidth="3" fill="none" />
            <path d="M255,45 C255,36 264,35 270,35 C276,35 285,36 285,45" stroke="#2563eb" strokeWidth="3" fill="none" />
        </g>

        {/* 右側設備模擬 */}
        <g transform="translate(0, 0)">
            {/* 平板設備邊框 */}
            <rect x="780" y="100" width="280" height="200" rx="10" ry="10" fill="#ffffff" filter="url(#dropShadow)" />

            {/* 設備螢幕內容 */}
            <g clipPath="url(#deviceShape)">
                {/* 螢幕背景 */}
                <rect x="780" y="100" width="280" height="200" fill="#f3f4f6" />

                {/* 頂部導航欄 */}
                <rect x="780" y="100" width="280" height="40" fill="#ffffff" />
                <circle cx="800" cy="120" r="8" fill="#3b82f6" />
                <text x="815" y="125" fontFamily="Arial, sans-serif" fontSize="12" fill="#1e3a8a">智能出勤系統</text>

                {/* 儀表板內容 */}
                <rect x="790" y="150" width="120" height="60" rx="5" ry="5" fill="#ffffff" stroke="#e5e7eb" strokeWidth="1" />
                <text x="800" y="170" fontFamily="Arial, sans-serif" fontSize="10" fill="#6b7280">出勤率</text>
                <text x="800" y="190" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" fill="#2563eb">96.5%</text>
                <path d="M870,190 L875,180 L880,185 L885,175 L890,170 L895,180" stroke="#22c55e" strokeWidth="2" fill="none" />

                <rect x="920" y="150" width="120" height="60" rx="5" ry="5" fill="#ffffff" stroke="#e5e7eb" strokeWidth="1" />
                <text x="930" y="170" fontFamily="Arial, sans-serif" fontSize="10" fill="#6b7280">異常打卡</text>
                <text x="930" y="190" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" fill="#ef4444">3</text>
                <circle cx="970" cy="180" r="12" fill="#fee2e2" />
                <text x="965" y="185" fontFamily="Arial, sans-serif" fontSize="14" fill="#ef4444">!</text>

                {/* 表格數據 */}
                <rect x="790" y="220" width="250" height="70" rx="5" ry="5" fill="#ffffff" stroke="#e5e7eb" strokeWidth="1" />
                <line x1="790" y1="240" x2="1040" y2="240" stroke="#e5e7eb" strokeWidth="1" />
                <line x1="790" y1="260" x2="1040" y2="260" stroke="#e5e7eb" strokeWidth="1" />
                <line x1="870" y1="220" x2="870" y2="290" stroke="#e5e7eb" strokeWidth="1" />
                <line x1="950" y1="220" x2="950" y2="290" stroke="#e5e7eb" strokeWidth="1" />

                <text x="800" y="235" fontFamily="Arial, sans-serif" fontSize="8" fill="#6b7280">員工</text>
                <text x="880" y="235" fontFamily="Arial, sans-serif" fontSize="8" fill="#6b7280">時間</text>
                <text x="960" y="235" fontFamily="Arial, sans-serif" fontSize="8" fill="#6b7280">狀態</text>

                <text x="800" y="255" fontFamily="Arial, sans-serif" fontSize="8" fill="#1f2937">王小明</text>
                <text x="880" y="255" fontFamily="Arial, sans-serif" fontSize="8" fill="#1f2937">09:00</text>
                <rect x="960" y="248" width="40" height="12" rx="6" ry="6" fill="#dcfce7" />
                <text x="970" y="256" fontFamily="Arial, sans-serif" fontSize="7" fill="#16a34a">正常</text>

                <text x="800" y="275" fontFamily="Arial, sans-serif" fontSize="8" fill="#1f2937">李小華</text>
                <text x="880" y="275" fontFamily="Arial, sans-serif" fontSize="8" fill="#1f2937">09:15</text>
                <rect x="960" y="268" width="40" height="12" rx="6" ry="6" fill="#fee2e2" />
                <text x="970" y="276" fontFamily="Arial, sans-serif" fontSize="7" fill="#dc2626">遲到</text>
            </g>
        </g>

        {/* 行動呼籲按鈕 */}
        <rect x="120" y="330" width="180" height="40" rx="20" ry="20" fill="#ffffff" />
        <text x="160" y="356" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" fill="#2563eb">
            立即免費試用
        </text>
    </svg>
);

const HeroBanner = () => {
    return (
        <section className="bg-gradient-to-r from-primary-600 to-primary-800 text-white py-16 md:py-24">
            <div className="container mx-auto">
                <div className="flex flex-col md:flex-row items-center">
                    <div className="md:w-1/2 mb-8 md:mb-0">
                        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-4">
                            提升企業管理效率，<br />從智能管理開始！
                        </h1>
                        <p className="text-xl opacity-90 mb-8">
                            整合出勤、薪資、績效、排班於一體的 SaaS 人事管理系統，讓您的企業管理更智能、更高效、更安全。
                        </p>
                        <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
                            <Link
                                to="/contact"
                                className="px-8 py-3 bg-white text-primary-700 font-medium rounded-lg hover:bg-gray-100 text-center"
                            >
                                免費試用
                            </Link>
                            <Link
                                to="/demo"
                                className="border border-white text-white font-medium rounded-lg hover:bg-primary-700 text-center px-8 py-3"
                            >
                                觀看演示
                            </Link>
                        </div>
                    </div>
                    <div className="md:w-1/2">
                        <BannerSVG />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroBanner;